import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";

export type BehaviourEventMessage<D extends object> = {
    type: string;
    payload: Partial<D>;
};

/** Event stream, which stores the latest value. Each event type can send partial data   */
export class EventStreamWithStoredValue<
    D extends object,
    T extends BehaviourEventMessage<D>,
    StoredType extends { type: T["type"]; payload: D } = { type: T["type"]; payload: D }
> {
    public subject = new BehaviorSubject<StoredType | null>(null);

    listen(events?: T["type"][]) {
        if (events != null) {
            return this.subject.pipe(filter((ms) => ms?.type !== undefined && events.includes(ms?.type)));
        }
        return this.subject;
    }

    next(event: T) {
        const value = this.subject.getValue();
        this.subject.next({ type: event.type, payload: { ...value?.payload, ...event.payload } } as StoredType);
    }

    destroy() {
        this.subject.complete();
    }

    restart() {
        this.subject = new BehaviorSubject<StoredType | null>(null);
    }
}
